import ApiService from './api.service';
export default class RelationService {
  static async findRelation(relationId) {
    return await ApiService.get(`/resources/relations/all/${relationId}`);
  }
  static async generateSceneDict(resourceId, relations) {
    return await ApiService.post(`/resources/relations/sceneDict/${resourceId}`, relations);
  }
  static async updateSceneDict(resourceId, relations) {
    return await ApiService.put(`/resources/relations/sceneDict/${resourceId}`, relations);
  }
}
